export const CALENDAR_PAGE_SIZE = 200

export function parseCalendarYear(value) {
  const text = String(value).trim()
  if (!/^\d{4}$/.test(text)) return null
  const year = Number(text)
  return year >= 2000 && year <= 2100 ? year : null
}

// Aborting saves work when supported. The identity check also rejects a late response
// from a transport that completes despite cancellation.
export function createLatestCalendarRequest() {
  let current = null
  return {
    begin() {
      current?.abort()
      const controller = new AbortController()
      current = controller
      return {
        signal: controller.signal,
        isCurrent: () => current === controller && !controller.signal.aborted,
      }
    },
    cancel() {
      current?.abort()
      current = null
    },
  }
}

export function calendarSyncErrorLabel(code) {
  const labels = {
    SOURCE_YEAR_NOT_FOUND: 'A fonte não forneceu eventos do ano solicitado.',
    SOURCE_NO_RECOGNIZED_EVENTS: 'Não foi possível extrair eventos desta página. Ela pode conter apenas resumos ou links.',
    SOURCE_UNSUPPORTED_RECURRENCE: 'O calendário contém uma recorrência ainda não suportada.',
    SOURCE_UNRECOGNIZED_LAYOUT: 'O formato da página não corresponde ao esperado.',
    SOURCE_CACHE_LINEAGE_MISSING: 'A fonte não reenviou o documento, mas não há uma importação anterior compatível. É necessário sincronizar novamente para validar os eventos.',
    INVALID_SOURCE_DOCUMENT: 'O documento não pôde ser validado. Consulte o log do serviço para identificar a causa.',
  }
  return labels[code] || code || '-'
}
